import moment from "moment";
import { Cell } from "react-table";
import { ContractManageList } from "src/api/contract/contract-types";
import { ProductModel } from "src/api/product/product-types";
import { PagePath } from "src/pages/product/details";
import ProductTypeChangeLabel from "src/components/ProductTypeChangeLabel";
import { ViewYmdFormat } from "src/utils/common-util";
import { BaseContractStatus } from "src/components/BaseContractStatus";
import Link from "src/components/PartnerLink";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import ContractManageIdLinkCell from "src/components/contract/ContractManageIdLinkCell";

// 상품 연결 id 는 파트너가 이용할 일이 없는 값이라 노출하지 않는다.
export const iotConnectedProductColumns = [
  {
    Header: "상품유형",
    accessor: "productType",
    width: 160,
    Cell: (props: Cell<ProductModel>) => <ProductTypeChangeLabel productType={props.row.original.productType} />,
  },
  {
    Header: "상품명",
    accessor: "productName",
    width: 700,
    Cell: ({ row, value }: Cell<ProductModel>) => {
      return (
        <BaseNewTabLink path={PagePath.product.detail.replace(":id", `${row.original.id}`)} value={value} ellipsis />
      );
    },
  },
];

export const iotConnectedContractColumns = [
  {
    // 신청번호(난수) 대체 컬럼.
    // 재계약이 있으면 같은 계약관리 ID가 여러 행에 나오는데, 어느 행에서 눌러도
    // 계약상태가 '이용중'인 계약(없으면 최신 계약)으로 이동한다.
    Header: "계약관리 ID",
    accessor: "contractManageId",
    width: 140,
    Cell: ({ data, row }: any) => (
      <ContractManageIdLinkCell
        contractManageId={row.original.contractManageId}
        contractManageIdsInPage={data.map((item: ContractManageList) => item.contractManageId)}
      />
    ),
  },
  {
    Header: "상품명",
    accessor: "productName",
    width: 200,
    Cell: ({ value }: Cell<ContractManageList>) => <span>{value || "-"}</span>,
  },
  {
    Header: "계약명",
    accessor: "contractName",
    width: 250,
    Cell: ({ value }: Cell<ContractManageList>) => <span>{value || "-"}</span>,
  },
  {
    Header: "이용기간",
    accessor: "contractPeriod",
    width: 250,
    Cell: ({ row }: Cell<ContractManageList>) => {
      const { contractStartTime, contractEndTime } = row.original;
      if (!contractStartTime || !contractEndTime) {
        return <span>-</span>;
      }
      return (
        <span>
          {moment(contractStartTime).format(ViewYmdFormat.YYYY_MM_DD)} ~ {moment(contractEndTime).format(ViewYmdFormat.YYYY_MM_DD)}
        </span>
      );
    },
  },
  {
    Header: "이용상태",
    accessor: "contractStep",
    width: 100,
    Cell: ({ value }: Cell<ContractManageList>) => {
      return <BaseContractStatus status={value} />;
    },
  },
];
